import secureLocalStorage from "react-secure-storage";
import { useAuth } from "../../../context/auth";
import { useEffect, useMemo, useRef, useState } from "react";
import {
  DeleteUser,
  GetGpUnidades,
  GetSuppliersByUnity,
  GetUnidadesFornecedor,
  GetUsers,
  GetUsersUnidadeByIdUsuario,
  PostUser,
} from "../../../data/services";
import ConfirmDeleteModal from "../components/ConfirmDeleteModal";
import { toast } from "react-toastify";
import AdicionarColaborador from "./AdicionarUsuarios/Colaborador";
import EditarColaborador from "./EditarUsuarios/EditarUsuarioColaborador";
import EditarFornecedor from "./EditarUsuarios/EditarUsuarioFornecedor";
import AdicionarFornecedor from "./AdicionarUsuarios/Fornecedor";

const AdminUsuarios = () => {
  const { user } = useAuth();
  const profile = user.profile;

  if (profile === "usuarioFornecedor") window.location.href = "/home";
  const token: any = secureLocalStorage.getItem("access_token");
  if (!token) {
    window.location.href = "/";
  }
  const UnidadeAdmin = "adminUnidade";
  const SuperAdmin = "superAdmin";
  const adm = profile === SuperAdmin || profile === UnidadeAdmin;

  const [usuariosOption, setUsuariosOption] = useState<any>([]);
  const [users, setUsers] = useState<any>([]);

  const [editando, setEditando] = useState<any>(null);

  const [openAdicionar, setOpenAdicionar] = useState<{
    open: boolean;
    tipo?: "GP" | "FORN";
  }>({ open: false });
  const [selectedUser, setSelectedUser] = useState<any>(null);
  const [isModalOpen, setIsModalOpen] = useState(false);

  const [showDropdown, setShowDropdown] = useState(false);
  const dropdownRef = useRef<any>(null);

  useEffect(() => {
    GetUsers(setUsuariosOption);
    GetSuppliersByUnity(setUsers);
  }, []);

  const handleConfirmDelete = async () => {
    try {
      await DeleteUser(selectedUser?.idUsuario);
      toast.success("Usuário deletado com sucesso!");
      setTimeout(() => {
        window.location.reload();
      }, 1000);
    } catch (error) {
      toast.error("Erro ao deletar usuário.");
    } finally {
      toggleModal();
    }
  };
  const toggleModal = () => setIsModalOpen(!isModalOpen);

  // Salvar e atualizar lista
  async function handleSaveColaborador(object: {
    nomeUsuario: string;
    email: string;
    tipo: string;
    login: string;
    perfilAcesso: string;
  }): Promise<any> {
    const result = await PostUser(object);
    return result; 
  }

  const handleOptionClick = (tipo: "GP" | "FORN") => {
    setShowDropdown(false);
    setOpenAdicionar({ open: true, tipo });
  };

  const handleCloseModal = () => {
    setEditando(null);
    setTimeout(() => {
      window.location.reload();
    }, 50);
  };

  // Helper: considera TERCEIRO como colaborador (mesmo fluxo de GP)
  const isColaborador = (u: any) => u?.tipo === "GP" || u?.tipo === "TERCEIRO";

  const handleEditarUsuario = async (user: any) => {
    try {
      const unidadesUsuario = await GetUsersUnidadeByIdUsuario(user.idUsuario);

      let todasUnidades: any[] = [];

      if (isColaborador(user)) {
        // GP e TERCEIRO usam as unidades GP
        todasUnidades = await GetGpUnidades();
      } else if (user.tipo === "FORN") {
        todasUnidades = await GetUnidadesFornecedor();
      }

      const unidadesRelacionadas = unidadesUsuario
        .map((item: any) => {
          if (isColaborador(user)) {
            return todasUnidades.find(
              (u: any) => u.idGpUnidade === item.ID_UNIDADE
            );
          } else if (user.tipo === "FORN") {
            return todasUnidades.find(
              (u: any) => u.id_fornecedor_unidade === item.ID_UNIDADE
            );
          }
          return null;
        })
        .filter(Boolean);

      const unidadePrincipal = isColaborador(user)
        ? todasUnidades.find((u: any) => u.idGpUnidade == user.idFabrica)
            ?.idGpUnidade ?? ""
        : todasUnidades.find(
            (u: any) => u.id_fornecedor_unidade == user.idFabrica
          )?.id_fornecedor_unidade ?? "";

      setEditando({
        ...user,
        unidades: unidadesRelacionadas,
        todasUnidades,
        unidadePrincipal,
      });
    } catch (err) {
      toast.error("Erro ao buscar unidades do usuário");
      console.error(err);
    }
  };

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setShowDropdown(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const ListColumns = useMemo(() => {
    return (
      <>
        <table className="table" style={{ marginLeft: "30px" }}>
          <thead
            style={{
              textAlign: "center",
            }}
          >
            <td className="col-md-2">Nome de usuário</td>
            <td className="col-md-2">Tipo</td>
            <td className="col-md-2">Login</td>
            <td className="col-md-2">Perfil de acesso</td>
            {adm && <td className="col-md-2">Ações</td>}
          </thead>
        </table>
      </>
    );
  }, [adm]);

  const List = useMemo(() => {
    return (
      <>
        {usuariosOption
          .sort(function (a: any, b: any) {
            if (a.nomeUsuario > b.nomeUsuario) {
              return 1;
            }
            if (a.nomeUsuario < b.nomeUsuario) {
              return -1;
            }
            return 0;
          })
          .map((item: any) => {
            return (
              <>
                <div
                  className="row"
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    flexDirection: "column",
                    padding: 5,
                    borderBottom: "1px solid #dddddd",
                  }}
                >
                  <tr style={{ display: "flex" }}>
                    <td className="listTd">{item.nomeUsuario}</td>
                    <td className="listTd">{item.tipo}</td>
                    <td className="listTd">{item.login}</td>
                    <td className="listTd">
                      {item?.perfilAcesso ? item?.perfilAcesso : "~~"}
                    </td>
                    {adm && (
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "flex-end",
                          columnGap: "5px",
                          marginLeft: "10px",
                        }}
                      >
                        <button
                          className="btn btn-light"
                          onClick={() => handleEditarUsuario(item)}
                        >
                          Editar
                        </button>
                        <button
                          className="btn btn-danger"
                          onClick={() => {
                            setIsModalOpen(true);
                            setSelectedUser(item);
                          }}
                          style={{ float: "right" }}
                        >
                          Deletar
                        </button>
                      </div>
                    )}
                  </tr>
                </div>
              </>
            );
          })}
      </>
    );
  }, [usuariosOption, adm]);

  return (
    <div className="modalSignUp">
      <div className="content-header-button-and-title">
        <h1>Usuários</h1>

        {adm && (
          <div style={{ position: "relative" }} ref={dropdownRef}>
            <button
              className="BtnClean"
              onClick={() => setShowDropdown(!showDropdown)}
            >
              Adicionar ▼
            </button>

            {showDropdown && (
              <div
                style={{
                  position: "absolute",
                  top: "110%",
                  right: 0,
                  backgroundColor: "white",
                  boxShadow: "0 2px 8px rgba(0, 0, 0, 0.1)",
                  borderRadius: "4px",
                  zIndex: 999,
                  minWidth: 160,
                }}
              >
                <button
                  style={dropdownItemStyle}
                  onClick={() => handleOptionClick("GP")}
                >
                  Adicionar Colaborador
                </button>
                <button
                  style={dropdownItemStyle}
                  onClick={() => handleOptionClick("FORN")}
                >
                  Adicionar Fornecedor
                </button>
              </div>
            )}
          </div>
        )}
      </div>

      <div className="contentList">{ListColumns}</div>
      <div className="content">
        <div className="containerListInfo">
          {usuariosOption.length > 0 ? (
            <>{List}</>
          ) : (
            <div style={{ textAlign: "center" }}>
              <h1 style={{ margin: "35px 0", fontSize: 28 }}>
                Não há registros aqui
              </h1>
            </div>
          )}
        </div>
      </div>

      {openAdicionar.open && openAdicionar.tipo === "GP" && (
        <AdicionarColaborador
          onSave={handleSaveColaborador}
          onCancel={() => setOpenAdicionar({ open: false })}
        />
      )}

      {openAdicionar.open && openAdicionar.tipo === "FORN" && (
        <AdicionarFornecedor
          onSave={handleSaveColaborador}
          onCancel={() => setOpenAdicionar({ open: false })}
        />
      )}

      {/* Agora mostra o modal para GP e TERCEIRO */}
      {isColaborador(editando) && (
        <EditarColaborador userData={editando} onCancel={handleCloseModal} />
      )}

      {editando?.tipo === "FORN" && (
        <EditarFornecedor userData={editando} onCancel={handleCloseModal} />
      )}

      <ConfirmDeleteModal
        isOpen={isModalOpen}
        toggle={toggleModal}
        onConfirm={handleConfirmDelete}
        itemName={selectedUser?.nomeUsuario ?? ""}
      />
    </div>
  );
};

export default AdminUsuarios;

const dropdownItemStyle = {
  width: "100%",
  padding: "10px 16px",
  textAlign: "left" as const,
  background: "white",
  border: "none",
  borderBottom: "1px solid #eee",
  cursor: "pointer",
  fontSize: "14px",
};
